import { Container, Grid, Typography, makeStyles } from "@material-ui/core";

import { ITheme } from "../constants/theme";
import { IMerchantInfo } from '../redux/reducers/getMerchantInfo';
import { useTranslation } from 'react-i18next';

interface IProps{
  data: IMerchantInfo;
  shop: string;
}
export const OrderDetailsMerchantInfoSection = ({data, shop}: IProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Container className={classes.merchantInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
{t('admin.merchantAndShopInformation')}
          </Typography>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
              data-automation="order-id-main"
            >
{t('admin.name')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.Name}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
{t('admin.email')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.Email}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
{t('admin.phone')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.Phone}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainerLastRow}>
          <Grid
            container
            item
            xs={3}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography
              variant="caption"
              component="span"
              color="textSecondary"
            >
{t('admin.collectionAddress')}
            </Typography>
          </Grid>
          <Grid item xs={9} className={classes.colOffset}>
            <Grid item xs={12}>
              <Typography variant="body1" component="span" color="textPrimary">
                {GetAddressLine(data)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
const GetAddressLine = (data: IMerchantInfo) => {
  const addressLines =
    (data?.AddressLine2 === null || data?.AddressLine2 === ""
      ? ""
      : " " + data?.AddressLine2) +
    (data?.AddressLine3 === null || data?.AddressLine3 === ""
      ? ""
      : " " + data?.AddressLine3);
  const addressLineWhiteSpace = addressLines.length === 0 ? "" : " ";
  return (
    data?.AddressLine1?.trim() +
    ", " +
    addressLines +
    addressLineWhiteSpace +
    data.City +
    " " +
    data.PostalCode +
    ", " +
    data.County
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  merchantInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    marginTop: "24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
